import { Component, Input, OnInit } from '@angular/core';
import formatDate from '../../../helpers/format-date';
import {
  IReport,
  IReportData,
  IReportDataInventoryByCrate,
  IReportDataInventoryByPigeonholePosition,
  translateType
} from '../../../../models/Report';
import { InventoryTypesEnum } from '../../../core/services/action.service';
import getName from 'src/app/helpers/format-name';
import { getGroupOrPositionName } from 'src/app/helpers/get-inventory-type-position-group';

@Component({
  selector: 'app-reports-table-item',
  templateUrl: './reports-table-item.component.html',
  styleUrls: ['./reports-table-item.component.scss']
})
export class ReportsTableItemComponent implements OnInit {
  @Input() report: IReport;
  reportData: IReportData | IReportDataInventoryByCrate | IReportDataInventoryByPigeonholePosition;
  totalItems: number;
  qtyFound: number;
  qtyMissing: number;
  formatDate = formatDate;

  constructor() {
  }

  ngOnInit(): void {
    this.setReportType();
  }

  setReportType(): void {
    switch (this.report.data.type) {
      case InventoryTypesEnum.INVENTORY_BY_PIGEONHOLE_POSITION:
        this.setPigeonholeReportType();
        break;
      case InventoryTypesEnum.PRODUCT_INVENTORY_BY_CRATE_TAG_RFID:
        this.setInventoryByCrateReportType();
        break;
      case InventoryTypesEnum.INVENTORY_BY_TAG_RFID:
      case InventoryTypesEnum.INVENTORY_BY_ITEM_SKU:
      case InventoryTypesEnum.INVENTORY_BY_ITEM_SET:
      case InventoryTypesEnum.INVENTORY_BY_ITEM_PACKAGE:
      case InventoryTypesEnum.INVENTORY_BY_ITEM_TYPE:
      case InventoryTypesEnum.INVENTORY_BY_GROUND_POSITION_GROUP:
      case InventoryTypesEnum.INVENTORY_BY_GROUND_POSITION:
      case InventoryTypesEnum.INVENTORY_BY_MISSING_CRATE:
      default:
        this.setDefaultReportType();
        break;
    }
  }

  private setPigeonholeReportType(): void {
    this.reportData = this.report.data as IReportDataInventoryByPigeonholePosition;

    const mergedItems = [
      ...(this.reportData?.packages || []),
      ...(this.reportData?.pallets || [])
    ];

    this.totalItems = this.report.total?.items || mergedItems.length;
    this.qtyFound = this.report.total?.found || this.countStates(mergedItems, ['FOUND', 'FOUND_MISPLACED']);
    this.qtyMissing = this.report.total?.missing || this.countStates(mergedItems, ['MISSING']);
  }

  private setInventoryByCrateReportType(): void {
    this.reportData = this.report.data as IReportDataInventoryByCrate;
    this.totalItems = this.report.total?.items || this.reportData?.skuGroup?.found?.length + this.reportData?.skuGroup?.extra?.length + this.reportData?.skuGroup?.missing?.length;
    this.qtyFound = this.reportData?.skuGroup?.found?.length + this.reportData?.skuGroup?.extra?.length;
    this.qtyMissing = this.reportData?.skuGroup?.missing?.length;
  }

  private setDefaultReportType(): void {
    this.reportData = this.report.data as IReportData;
    this.totalItems = this.report.total?.items || this.reportData?.found?.length + this.reportData?.foundMisplaced?.length + this.reportData?.missing?.length
    this.qtyFound = this.report.total?.found || this.reportData?.found?.length + this.reportData?.foundMisplaced?.length
    this.qtyMissing = this.report.total?.missing || this.reportData?.missing?.length;
  }

  private countStates(items, states: string[]): number {
    return items.filter((item) => states.includes(item?.state)).length;
  }

  translateTypeName(reportData: IReportData | IReportDataInventoryByCrate | IReportDataInventoryByPigeonholePosition): string | string[] {
    switch (reportData.type) {
      case InventoryTypesEnum.INVENTORY_BY_GROUND_POSITION:
      case InventoryTypesEnum.INVENTORY_BY_PIGEONHOLE_POSITION:
        return getGroupOrPositionName(reportData, 'groundPositions', 'alias');
      case InventoryTypesEnum.INVENTORY_BY_GROUND_POSITION_GROUP:
        return getGroupOrPositionName(reportData, 'groundPositionGroups', 'name');
      default:
        return translateType(reportData.type);
    }
  }

  getUserName(user) {
    return getName(user);
  }
}
